import React, { Children, useEffect, useState } from 'react'

const supportsAvif = () =>
  new Promise((resolve, reject) => {
    const avif = new Image()
    // bascially just a grey dot
    avif.src =
      'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A='
    avif.onload = () => resolve(true)
    avif.onerror = () => reject(Error('AVIF is not supported'))
  })

const useImageSupport = (callback) => {
  const [isSupported, setIsSupported] = useState(true)

  useEffect(() => {
    const checkSupport = async () => {
      try {
        await callback()
        // I already assume it's not supported; no need to set state
      } catch (error) {
        setIsSupported(false)
      }
    }
    checkSupport()
  }, [callback])

  return isSupported
}

export const useAvifSupport = () => useImageSupport(supportsAvif)

const supportsWebp = () =>
  new Promise((resolve, reject) => {
    const webp = new Image()
    // bascially just a grey dot
    webp.src =
      'data:image/webp;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A='
    webp.onload = () => resolve(true)
    webp.onerror = () => reject(Error('WEBP is not supported'))
  })

export const useWebpSupport = () => useImageSupport(supportsWebp)

const Picture = ({ sources, alt, ...rest }) => {
  return (
    <picture>
      {Children.toArray(
        sources.map((src, index) => {
          if (index !== sources.length - 1) return <source type={src.type} srcSet={src.img} />
          return <img src={src.img} alt={alt} {...rest} />
        })
      )}
    </picture>
  )
}

export default Picture
